exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.arrow-square[data-v-4784d60c],ul.arrow[data-v-4784d60c],ul.check-circle[data-v-4784d60c],ul.check-square[data-v-4784d60c],ul.check[data-v-4784d60c],ul.chevron[data-v-4784d60c],ul.circle[data-v-4784d60c],ul.decimal[data-v-4784d60c],ul.lower-latin[data-v-4784d60c],ul.triangle[data-v-4784d60c],ul.upper-latin[data-v-4784d60c],ul.upper-roman[data-v-4784d60c]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-4784d60c]{font-size:1.6em}.booking-information[data-v-4784d60c]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4784d60c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/important-infos/Home.vue
// module id = 489
// module chunks = 0